import React from "react";
import { Link } from "react-router-dom";
import vetroLogo from "../../assets/img/layout/vetropack-logo.svg";
import * as Sentry from "@sentry/browser";
import SupportList from "../footer/SupportList";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorMessage: "" };
    this.removeErr = this.removeErr.bind(this);
  }

  componentDidCatch(error, info) {
    Sentry.captureException(error, {
      extra: {
        componentStack: info?.componentStack,
      },
    });
    this.setState({ hasError: true, errorMessage: error.message });
  }

  removeErr() {
    this.setState({ hasError: false, errorMessage: "" });
  }

  render() {
    if (this.state.hasError) {
      return (
        <React.Fragment>
          <div className="header-wrap" style={{ top: "0px" }}>
            <nav className="meta-nav phone-tablet--hidden">
              <h2 className="visually-hidden">Meta Navigation</h2>
              <div className="meta-nav__container" />
            </nav>
            <header className="header">
              <h2 className="visually-hidden">Header</h2>
              <div className="header__container">
                <Link to={"/catalogue/result/global/all#ph=1"} onClick={this.removeErr}>
                  <div className="header__logo--center">
                    <div className="header__logo" style={{ marginLeft: "0px" }}>
                      <h2 className="visually-hidden">Vetropack Logo</h2>
                      <img className="header-logo__img" src={vetroLogo} alt="Vetropack Logo" />
                    </div>
                  </div>
                </Link>
              </div>
            </header>
          </div>
          <div className="emptypage-main">
            <div className="emptypage-layer" key="errorpage">
              <div className="emptypage-layer__content">
                <div className="emptypage-layer__title">
                  {/*404*/} <span className="emptypage-layer-title__text">Error</span>
                </div>
                <div className="emptypage-layer__text">{this.state.errorMessage}</div>
                <SupportList />
              </div>
            </div>
          </div>
        </React.Fragment>
      );
    }
    return this.props.children;
  }
}
